"use client";

import type { ReactNode } from "react";
import { ShoppingCart, Tag, Recycle } from "@/components/icons";
import { RFQ_TYPES, type RfqType } from "@convex/constants/types";
import { OptionCard } from "@/components/wizard/wizard-ui";
import { isOneOf } from "@shared/type-guards";

interface ServiceTypeStepProps {
  value: RfqType;
  onSelect: (type: RfqType) => void;
}

interface ServiceOption {
  type: RfqType;
  icon: ReactNode;
  label: string;
}

const SERVICE_FIELD = "service";

const SERVICE_OPTIONS: ReadonlyArray<ServiceOption> = [
  { type: "buy", icon: <ShoppingCart className="h-6 w-6" />, label: "Buy packaging" },
  { type: "sell", icon: <Tag className="h-6 w-6" />, label: "Sell my inventory" },
  { type: "recycle", icon: <Recycle className="h-6 w-6" />, label: "Recycle materials" },
];

export function ServiceTypeStep({ value, onSelect }: ServiceTypeStepProps) {
  const selectService = (formData: FormData) => {
    const service = formData.get(SERVICE_FIELD);
    if (isOneOf(RFQ_TYPES, service)) onSelect(service);
  };
  return (
    <form
      action={selectService}
      className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-2xl mx-auto"
    >
      {SERVICE_OPTIONS.map((option) => (
        <OptionCard
          key={option.type}
          type="submit"
          name={SERVICE_FIELD}
          value={option.type}
          selected={value === option.type}
          icon={option.icon}
          label={option.label}
        />
      ))}
    </form>
  );
}
